/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../../../node_modules/@corteva-research/ngx-components-compat/corteva-research-ngx-components-compat.ngfactory";
import * as i2 from "@corteva-research/ngx-components-compat";
import * as i3 from "./login.component";
import * as i4 from "@angular/router";
import * as i5 from "research.oidc.angular";
var styles_LoginComponent = [];
var RenderType_LoginComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_LoginComponent, data: {} });
export { RenderType_LoginComponent as RenderType_LoginComponent };
export function View_LoginComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "res-login", [], null, [[null, "loginCallback"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("loginCallback" === en)) {
        var pd_0 = (_co.login() !== false);
        ad = (pd_0 && ad);
    } return ad; }, i1.View_LoginComponent_0, i1.RenderType_LoginComponent)), i0.ɵdid(1, 49152, null, 0, i2.LoginComponent, [], null, { loginCallback: "loginCallback" })], null, null); }
export function View_LoginComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_LoginComponent_0, RenderType_LoginComponent)), i0.ɵdid(1, 114688, null, 0, i3.LoginComponent, [i4.Router, i5.ResearchAuthService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LoginComponentNgFactory = i0.ɵccf("ng-component", i3.LoginComponent, View_LoginComponent_Host_0, {}, {}, []);
export { LoginComponentNgFactory as LoginComponentNgFactory };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/login/login.component.ngfactory.js.pre-build-optimizer.js